export default "__VITE_ASSET__CLgPJfYv__"